// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","tooltip":"tooltip_tooltip__4+7c7","triangle":"tooltip_triangle__2EzG7","tooltipBody":"tooltip_tooltipBody__2F-++"};